export default "__VITE_ASSET__Ca4i5sNv__"